import React from 'react';
import DataTable from '../reporting_utils/DataTable';

const $ = window.$;

/**
 * @param {{ tableData: Array; isAutomotiveIndustry: boolean }} props
 */
export default function LocationCallTypeTable({ tableData, isAutomotiveIndustry }) {
  function buildColumnDefs() {
    /** @type {import('../reporting_utils/DataTable').ColumnDef[]} */
    const columns = [];
    columns.push({ data: 'customername', title: 'Location' });
    if (isAutomotiveIndustry) {
      columns.push({
        data: 'prospects',
        render: $.fn.dataTable.render.number(','),
        aggregation: 'sum',
        title: 'Prospects',
      });
    } else {
      columns.push({
        data: 'qualified_leads',
        render: $.fn.dataTable.render.number(','),
        aggregation: 'sum',
        title: 'Prospects',
      });
    }
    columns.push({
      data: 'percentage',
      className: 'table_percent_bar',
      render: (data) => `
        <div class='bar_label'>${data}%</div>
        <div style='position:relative;' class='bar'>
          <div style='width:${data}%;' class='bar_filler'></div>
        </div>
      `,
      title: 'Prospect Percentage',
    });
    columns.push({
      data: 'non_prospects',
      render: $.fn.dataTable.render.number(','),
      aggregation: 'sum',
      title: isAutomotiveIndustry ? 'Non-Prospects' : 'Non-Leads',
    });
    columns.push({
      data: 'undetermined',
      render: $.fn.dataTable.render.number(','),
      aggregation: 'sum',
      title: 'Undetermined',
    });
    columns.push({
      data: 'total_calls',
      render: $.fn.dataTable.render.number(','),
      aggregation: 'sum',
      title: 'Total Calls',
    });
    return columns;
  }

  return (
    <div className='row row_top_buffer'>
      <div className='col-xs-12'>
        <div className='report_data_container'>
          <div className='title'>Location Call Type</div>
          <DataTable
            data={tableData}
            title='Location Call Type'
            columnDefs={buildColumnDefs()}
            showTotalFooter={true}
            order={[[5, 'desc']]}
          />
        </div>
      </div>
    </div>
  );
}
